export default __webpack_public_path__ + "static/media/gallery-wip-grenade v2_08.894f4acf.jpg";